<template>
  <v-menu bottom :close-on-content-click="false" transition="scale-transition" origin="top left" v-model="menuOpen" offset-y nudge-width="350">
    <template v-slot:activator="{on}">
      <v-btn v-on="on" small icon><v-icon>mdi-barcode-scan</v-icon></v-btn>
    </template>
    <v-card flat class="pa-3" width="400">

      <v-text-field :label="label" outlined dense hide-details v-model="enteredCode" @change="changed" append-outer-icon="mdi-camera"
                     @click:append-outer="cameraId?cameraOff():cameraOn()" autofocus/>

      <v-list v-if="pickCamera" v-model="cameraId">
        <v-list-item v-for="(camera,index) in cameras" :key="index" @click="useCamera(camera.id)">{{ camera.label }}</v-list-item>
      </v-list>
      <div id="reader" class="mt-2"/>
    </v-card>
  </v-menu>
</template>

<script>
import {Html5Qrcode} from 'html5-qrcode';

export default {
  name: 'Scan',
  props: {
    label: {type:String, required:false, default:'Scan code'},
    products: {type:Array, required:false, default:() => []},
    items: {type:Array, required:false, default:() => []},
    returnUnmatchedCode: {type:Boolean, required:false, default:false},
    autoClose: {type:Boolean, required:false, default:false}
  },
  data: () => {
    return {
      menuOpen: false,
      enteredCode: '',
      lastEvent: 0,
      html5QrCode: null,
      cameraId: null,
      cameras: [],
      pickCamera: false
    }
  },
  watch: {
    menuOpen() {
      if (!this.menuOpen && this.cameraId)
        this.cameraOff();
    }
  },
  methods: {
    changed(code) {
      this.enteredCode = '';

      const now = Date.now();
      if (now - this.lastEvent > 250) {     // Debounce to 0.25 seconds

        // Handle QR code that has all the info in it already
        if (code.startsWith('{'))
          try {
            this.$emit('code', JSON.parse(code));
          } catch(error) {}

        // Check UPC/SCC to find product/item and details
        else {
          let item = this.products.find(product => product.upc === code);
          if (item)
            this.$emit('code', {type:'Product', id:item.id, quantity:1, cases:false});
          else {
            item = this.products.find(product => product.scc === code);
            if (item)
              this.$emit('code', {type:'Product', id:item.id, quantity:1, cases:true});
            else {
              item = this.items.find(item => item.upc === code);
              if (item)
                this.$emit('code', {type:'Item', id:item.id, quantity:1, cases:false});
              else if (this.returnUnmatchedCode)
                this.$emit('code', {code});
            }
          }
        }
      }

      this.lastEvent = now;
      if (this.autoClose)
        this.menuOpen = false;
    },

    async cameraOff() {
      await this.html5QrCode.stop();
      this.cameraId = null;
    },
    async cameraOn() {
      if (!this.html5QrCode)
        this.html5QrCode = new Html5Qrcode('reader');

      try {
        this.cameras = await Html5Qrcode.getCameras();
        if (!this.cameras?.length)
          return;
        if (this.cameras?.length > 1) {
          this.pickCamera = true;
          return;
        }
        this.useCamera(this.cameras[0].id);
      } catch (error) {
        alert('Camera access is not allowed. You may have to update your browser settings.');
        return;
      }
    },
    async useCamera(id) {
      this.cameraId = id;
      try {
        await this.html5QrCode.start(this.cameraId,
                                    {fps: 10, qrbox: {width: 250, height: 250}},
                                    decodedText => this.changed(decodedText));
      } catch (error) {
        console.log(error);
      }
    }
  }
}
</script>